
import React, { useState, useEffect } from "react";

// reactstrap components
import {
    Button,
    Container,
    Row,
    Col,
    Card,
    CardBody,
} from "reactstrap";

import SectionCarousel from 'views/index-sections/SectionCarousel';

// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";
import CoursePageHeader from "components/Headers/CoursePageHeader.js";
import DemoFooter from "components/Footers/DemoFooter.js";

function Course() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        document.body.classList.add("profile-page");
        setIsVisible(true);
        return function cleanup() {
            document.body.classList.remove("profile-page");
        };
    }, []);

    const courseTopics = [
        { icon: "🤝", title: "Affiliate Marketing", description: "Learn to build profitable affiliate partnerships" },
        { icon: "📢", title: "Display Advertising", description: "Master banner ads and visual marketing campaigns" },
        { icon: "📧", title: "Email Marketing", description: "Create compelling email campaigns that convert" },
        { icon: "🔍", title: "Search Engine Marketing", description: "Dominate search results with SEM strategies" },
        { icon: "📱", title: "Social Media Marketing", description: "Engage audiences across all platforms" },
        { icon: "🎮", title: "In-Game Advertising", description: "Reach gamers where they play" },
        { icon: "📰", title: "Online Public Relations", description: "Build and manage your online reputation" },
        { icon: "🎥", title: "Video Advertising", description: "Create viral video content and ads" },
        { icon: "📝", title: "Content Marketing", description: "Tell stories that drive business results" },
        { icon: "🎯", title: "Native Advertising", description: "Seamless, non-intrusive advertising strategies" },
        { icon: "💰", title: "Sponsored Content", description: "Create authentic sponsored partnerships" },
        { icon: "💬", title: "SMS Marketing", description: "Direct communication with customers" },
        { icon: "🔔", title: "Push Notifications", description: "Re-engage users with smart notifications" },
        { icon: "📊", title: "Social Media Strategies", description: "Facebook, Instagram, LinkedIn, TikTok & Snapchat" },
        { icon: "🚀", title: "Entrepreneurship", description: "Build and scale your digital business" },
        { icon: "💡", title: "Startup Business Strategies", description: "Launch and grow your startup successfully" },
        { icon: "🎯", title: "Google Ads Management", description: "Master Google's advertising platform" },
        { icon: "📘", title: "Facebook Ads", description: "Create high-converting Facebook campaigns" },
        { icon: "📈", title: "Post Promotion Strategies", description: "Maximize reach and engagement" },
        { icon: "📊", title: "KPIs & Analytics", description: "Measure and optimize your marketing success" }
    ];

    return (
        <>
            <ExamplesNavbar />
            <CoursePageHeader />

            {/* Hero Section */}
            <div style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '100px 0',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* Animated Background Elements */}
                <div style={{
                    position: 'absolute',
                    top: '10%',
                    left: '5%',
                    width: '200px',
                    height: '200px',
                    background: 'rgba(255,255,255,0.1)',
                    borderRadius: '50%',
                    animation: 'float 6s ease-in-out infinite'
                }}></div>
                
                <div style={{
                    position: 'absolute',
                    bottom: '15%',
                    right: '8%',
                    width: '150px',
                    height: '150px',
                    background: 'rgba(255,255,255,0.05)',
                    borderRadius: '50%',
                    animation: 'float 8s ease-in-out infinite 2s'
                }}></div>

                <Container style={{ position: 'relative', zIndex: 2 }}>
                    <Row>
                        <Col className="text-center">
                            <div style={{
                                opacity: isVisible ? 1 : 0,
                                transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
                                transition: 'all 1s ease-out'
                            }}>
                                <h1 style={{
                                    color: 'white',
                                    fontSize: '4rem',
                                    fontWeight: '700',
                                    marginBottom: '30px',
                                    textShadow: '0 4px 10px rgba(0,0,0,0.4)'
                                }}>
                                    🎓 Digital Marketing Mastery
                                </h1>
                                
                                <h2 style={{
                                    color: '#feca57',
                                    fontSize: '2.5rem',
                                    fontWeight: '600',
                                    marginBottom: '40px',
                                    textShadow: '0 2px 6px rgba(0,0,0,0.3)'
                                }}>
                                    Transform Your Business with Expert Training
                                </h2>

                                <p style={{
                                    color: 'rgba(255,255,255,0.9)',
                                    fontSize: '1.4rem',
                                    maxWidth: '800px',
                                    margin: '0 auto 50px',
                                    lineHeight: '1.8',
                                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                                }}>
                                    Master digital marketing with our comprehensive 8-session course led by experienced professionals from London Universities. 
                                    Take your business to the next level with cutting-edge strategies and proven techniques!
                                </p>

                                <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', flexWrap: 'wrap' }}>
                                    <Button
                                        className="btn-round"
                                        style={{
                                            background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                                            border: 'none',
                                            padding: '20px 50px',
                                            borderRadius: '35px',
                                            color: 'white',
                                            fontWeight: '700',
                                            fontSize: '1.3rem',
                                            boxShadow: '0 10px 30px rgba(255, 107, 107, 0.4)',
                                            transition: 'all 0.3s ease'
                                        }}
                                        href="https://api.whatsapp.com/send/?phone=%2B96181906656&text&type=phone_number&app_absent=0"
                                        target="_blank"
                                    >
                                        <i className="fa fa-graduation-cap" style={{ marginRight: '10px' }} />
                                        Enroll Now
                                    </Button>

                                    <Button
                                        className="btn-round"
                                        style={{
                                            background: 'rgba(255,255,255,0.2)',
                                            backdropFilter: 'blur(10px)',
                                            border: '2px solid white',
                                            padding: '20px 50px',
                                            borderRadius: '35px',
                                            color: 'white',
                                            fontWeight: '700',
                                            fontSize: '1.3rem',
                                            boxShadow: '0 10px 30px rgba(255, 255, 255, 0.2)',
                                            transition: 'all 0.3s ease'
                                        }}
                                        href="#course-details"
                                    >
                                        Learn More
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Course Details Section */}
            <div id="course-details" style={{
                background: 'white',
                padding: '120px 0',
                position: 'relative'
            }}>
                    <Container>
                        <Row>
                        <Col className="text-center" style={{ marginBottom: '80px' }}>
                            <h2 style={{
                                color: '#333',
                                fontSize: '3.5rem',
                                fontWeight: '700',
                                marginBottom: '30px'
                            }}>
                                Course Overview
                            </h2>
                            <div style={{
                                width: '100px',
                                height: '5px',
                                background: 'linear-gradient(90deg, #667eea, #764ba2)',
                                margin: '0 auto 40px',
                                borderRadius: '3px'
                            }}></div>
                            <p style={{
                                color: '#666',
                                fontSize: '1.3rem',
                                maxWidth: '800px',
                                margin: '0 auto',
                                lineHeight: '1.8'
                            }}>
                                Comprehensive digital marketing training designed by industry experts to give you the competitive edge in today's digital landscape
                            </p>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="4" style={{ marginBottom: '40px' }}>
                            <div style={{
                                textAlign: 'center',
                                padding: '40px 30px',
                                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                borderRadius: '25px',
                                color: 'white',
                                boxShadow: '0 15px 35px rgba(240, 147, 251, 0.3)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}>
                                <div style={{
                                    fontSize: '4rem',
                                    marginBottom: '25px'
                                }}>
                                    🎯
                                </div>
                                <h3 style={{
                                    fontSize: '1.8rem',
                                    fontWeight: '600',
                                    marginBottom: '20px'
                                }}>
                                    8 Intensive Sessions
                                </h3>
                                <p style={{
                                    fontSize: '1.1rem',
                                    lineHeight: '1.7',
                                    opacity: '0.9'
                                }}>
                                    Each session lasts 60-75 minutes, packed with practical knowledge and real-world applications you can implement immediately.
                                </p>
                            </div>
                        </Col>

                        <Col md="4" style={{ marginBottom: '40px' }}>
                            <div style={{
                                textAlign: 'center',
                                padding: '40px 30px',
                                background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                                borderRadius: '25px',
                                color: 'white',
                                boxShadow: '0 15px 35px rgba(79, 172, 254, 0.3)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}>
                                <div style={{
                                    fontSize: '4rem',
                                    marginBottom: '25px'
                                }}>
                                    🏛️
                                </div>
                                <h3 style={{
                                    fontSize: '1.8rem',
                                    fontWeight: '600',
                                    marginBottom: '20px'
                                }}>
                                    London University Expertise
                                </h3>
                                <p style={{
                                    fontSize: '1.1rem',
                                    lineHeight: '1.7',
                                    opacity: '0.9'
                                }}>
                                    Learn from our experienced Marketing Manager with advanced education from prestigious London Universities and years of industry experience.
                                </p>
                            </div>
                        </Col>

                        <Col md="4" style={{ marginBottom: '40px' }}>
                            <div style={{
                                textAlign: 'center',
                                padding: '40px 30px',
                                background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
                                borderRadius: '25px',
                                color: 'white',
                                boxShadow: '0 15px 35px rgba(67, 233, 123, 0.3)',
                                transition: 'all 0.3s ease',
                                height: '100%'
                            }}>
                                <div style={{
                                    fontSize: '4rem',
                                    marginBottom: '25px'
                                }}>
                                    💼
                                </div>
                                <h3 style={{
                                    fontSize: '1.8rem',
                                    fontWeight: '600',
                                    marginBottom: '20px'
                                }}>
                                    Business-Focused
                                </h3>
                                <p style={{
                                    fontSize: '1.1rem',
                                    lineHeight: '1.7',
                                    opacity: '0.9'
                                }}>
                                    Everything you learn is designed to directly impact your business growth, from startup strategies to enterprise-level marketing.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Course Topics Section */}
            <div style={{
                background: 'linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)',
                padding: '120px 0',
                position: 'relative',
                overflow: 'hidden'
            }}>
                <Container>
                    <Row>
                        <Col className="text-center" style={{ marginBottom: '80px' }}>
                            <h2 style={{
                                color: 'white',
                                fontSize: '3.5rem',
                                fontWeight: '700',
                                marginBottom: '30px',
                                textShadow: '0 4px 8px rgba(0,0,0,0.3)'
                            }}>
                                What You'll Master
                            </h2>
                            <div style={{
                                width: '120px',
                                height: '5px',
                                background: 'linear-gradient(90deg, #ff6b6b, #feca57)',
                                margin: '0 auto 40px',
                                borderRadius: '3px'
                            }}></div>
                            <p style={{
                                color: 'rgba(255,255,255,0.9)',
                                fontSize: '1.3rem',
                                maxWidth: '700px',
                                margin: '0 auto',
                                lineHeight: '1.8'
                            }}>
                                20 comprehensive topics covering every aspect of modern digital marketing
                            </p>
                        </Col>
                    </Row>

                    <Row>
                        {courseTopics.map((topic, index) => (
                            <Col md="6" lg="4" style={{ marginBottom: '30px' }} key={index}>
                                <Card style={{
                                    background: 'rgba(255,255,255,0.1)',
                                    backdropFilter: 'blur(15px)',
                                    borderRadius: '20px',
                                    border: '2px solid rgba(255,255,255,0.2)',
                                    transition: 'all 0.3s ease',
                                    height: '100%'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-10px)';
                                    e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                                }}>
                                    <CardBody style={{ padding: '30px', textAlign: 'center' }}>
                                        <div style={{
                                            fontSize: '3rem',
                                            marginBottom: '20px'
                                        }}>
                                            {topic.icon}
                                        </div>
                                        <h4 style={{
                                            color: 'white',
                                            fontSize: '1.4rem',
                                            fontWeight: '600',
                                            marginBottom: '15px',
                                            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                                        }}>
                                            {topic.title}
                                        </h4>
                                        <p style={{
                                            color: 'rgba(255,255,255,0.8)',
                                            fontSize: '1rem',
                                            lineHeight: '1.6',
                                            margin: 0
                                        }}>
                                            {topic.description}
                                        </p>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>

            {/* Call to Action Section */}
            <div style={{
                background: 'white',
                padding: '120px 0',
                textAlign: 'center'
            }}>
                <Container>
                    <Row>
                        <Col>
                            <h2 style={{
                                color: '#333',
                                fontSize: '3.5rem',
                                fontWeight: '700',
                                marginBottom: '30px'
                            }}>
                                Ready to Transform Your Marketing?
                            </h2>
                            <p style={{
                                color: '#666',
                                fontSize: '1.4rem',
                                maxWidth: '700px',
                                margin: '0 auto 50px',
                                lineHeight: '1.8'
                            }}>
                                Join hundreds of entrepreneurs and business owners who have already elevated their digital marketing skills. 
                                Don't wait - your competitors are already learning!
                            </p>
                            
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', flexWrap: 'wrap' }}>
                                <Button
                                    className="btn-round"
                                    style={{
                                        background: 'linear-gradient(45deg, #25D366, #128C7E)',
                                        border: 'none',
                                        padding: '20px 50px',
                                        borderRadius: '35px',
                                        color: 'white',
                                        fontWeight: '700',
                                        fontSize: '1.3rem',
                                        boxShadow: '0 10px 30px rgba(37, 211, 102, 0.4)',
                                        transition: 'all 0.3s ease'
                                    }}
                                    href="https://api.whatsapp.com/send/?phone=%2B96181906656&text&type=phone_number&app_absent=0"
                                    target="_blank"
                                >
                                    <i className="fa fa-whatsapp" style={{ marginRight: '10px' }} />
                                    Enroll via WhatsApp
                                </Button>

                                <Button
                                    className="btn-round"
                                    style={{
                                        background: 'linear-gradient(45deg, #667eea, #764ba2)',
                                        border: 'none',
                                        padding: '20px 50px',
                                        borderRadius: '35px',
                                        color: 'white',
                                        fontWeight: '700',
                                        fontSize: '1.3rem',
                                        boxShadow: '0 10px 30px rgba(102, 126, 234, 0.4)',
                                        transition: 'all 0.3s ease'
                                    }}
                                    href="#contact"
                                >
                                    <i className="fa fa-envelope" style={{ marginRight: '10px' }} />
                                    Get Course Info
                </Button>
                            </div>
                            </Col>
                        </Row>
                    </Container>
                </div>

            {/* Add keyframes for animations */}
            <style>{`
                @keyframes float {
                    0%, 100% { transform: translateY(0) translateX(0); }
                    25% { transform: translateY(-20px) translateX(10px); }
                    50% { transform: translateY(-10px) translateX(-10px); }
                    75% { transform: translateY(-30px) translateX(5px); }
                }
            `}</style>

            <SectionCarousel />
            <DemoFooter />
        </>
    );
}

export default Course;
